import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const APP_STORE_URL = 'https://apps.apple.com/es/app/gluten-freends/id6479203808';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.glutenfreehub.app';
const REDIRECT_TIMEOUT_MS = 1000;

export const useAppRedirect = (deepLinkPath: string) => {
  const [attemptedAppOpen, setAttemptedAppOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isAndroid = /android/i.test(userAgent);

    if (!isIOS && !isAndroid) {
        navigate('/', { replace: true });
        return;
    }

    setAttemptedAppOpen(true);

    const customSchemeUrl = `glutenfreends://${deepLinkPath}`;
    window.location.href = customSchemeUrl;

    const timer = setTimeout(() => {
      if (document.hidden) return; 
      window.location.replace(isIOS ? APP_STORE_URL : PLAY_STORE_URL);
    }, REDIRECT_TIMEOUT_MS);

    return () => clearTimeout(timer);
  }, [deepLinkPath, navigate]);

  return { attemptedAppOpen };
};